import React, { ReactNode } from 'react';
import { useTheme } from '../../themer';
import { ArrowIcon } from '../Icon';
import { IIconLinkProps, StyledIconLink } from './IconLink';
import { LinkText } from './LinkText';

export interface IArrowLinkProps extends IIconLinkProps {
	className?: string;
	inverted?: boolean;
	children: ReactNode;
	screenReaderTitle?: string;
	customColor?: string;
}

export const ArrowLink = ({
	children,
	className,
	inverted,
	screenReaderTitle,
	customColor,
	...rest
}: IArrowLinkProps) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const theme: any = useTheme();
	const IconComponent = theme.link.ArrowLinkIcon ?? ArrowIcon;

	return (
		<StyledIconLink
			inverted={inverted}
			customColor={customColor}
			className={className}
			aria-label={screenReaderTitle}
			{...rest}
		>
			<LinkText ariaHidden={!!screenReaderTitle}>{children}</LinkText>
			<IconComponent aria-hidden />
		</StyledIconLink>
	);
};
